import { render, staticRenderFns } from "./EmbeddedLogin.vue?vue&type=template&id=2d1e6b88&scoped=true"
import script from "./EmbeddedLogin.vue?vue&type=script&lang=js"
export * from "./EmbeddedLogin.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedLogin.vue?vue&type=style&index=0&id=2d1e6b88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1e6b88",
  null
  
)

export default component.exports